import { useState } from "react";

/**
 * When the component that calls it mounted, on the `performance.now()` clock:
 * the time a reader spent on a card before a choice, without a clock kept
 * outside the card.
 */
export function useMountTime(): number {
  const [mountedAt] = useState(() => performance.now());
  return mountedAt;
}
